import React from 'react';

export const ABV = () => {
  return (
    <svg width="87" height="88" viewBox="0 0 87 88" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87 44.0077C87 68.0356 67.5203 87.5 43.5077 87.5C19.4797 87.5 0 68.0356 0 44.0077C0 19.9797 19.4797 0.5 43.5077 0.5C67.5203 0.5 87 19.9797 87 44.0077ZM83.9984 44.0077C83.9984 21.6336 65.8664 3.50159 43.5077 3.50159C21.1336 3.50159 3.00158 21.6336 3.00158 44.0077C3.00158 66.3664 21.1336 84.4984 43.5077 84.4984C65.8664 84.4984 83.9984 66.3664 83.9984 44.0077Z"
        fill="url(#paint0_radial_14427_90552)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.1797 43.9935C85.1797 67.1865 66.3803 85.9858 43.1873 85.9858C19.979 85.9858 1.17969 67.1865 1.17969 43.9935C1.17969 20.7852 19.979 1.98584 43.1873 1.98584C66.3803 1.98584 85.1797 20.7852 85.1797 43.9935ZM83.6641 43.9935C83.6641 21.6272 65.5384 3.50142 43.1873 3.50142C20.821 3.50142 2.69527 21.6272 2.69527 43.9935C2.69527 66.3445 20.821 84.4703 43.1873 84.4703C65.5384 84.4703 83.6641 66.3445 83.6641 43.9935Z"
        fill="url(#paint1_linear_14427_90552)"
      />
      <path
        d="M43.1994 84.4986C20.8254 84.4986 2.69336 66.3665 2.69336 44.0078C2.69336 21.6337 20.8254 3.50171 43.1994 3.50171C65.5582 3.50171 83.6902 21.6337 83.6902 44.0078C83.6902 66.3665 65.5582 84.4986 43.1994 84.4986Z"
        fill="url(#paint2_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M43.9833 78.863C25.5144 78.863 10.5371 63.8857 10.5371 45.4014C10.5371 26.9325 25.5144 11.9552 43.9833 11.9552C62.4676 11.9552 77.4449 26.9325 77.4449 45.4014C77.4449 63.8857 62.4676 78.863 43.9833 78.863Z"
        fill="url(#paint3_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.2657 67.3163C57.1521 81.2829 36.0338 82.7837 22.0673 70.6701C8.11602 58.5719 6.61523 37.4536 18.7135 23.4871C30.827 9.53582 51.9453 8.03503 65.8965 20.1333C79.8631 32.2468 81.3639 53.3651 69.2657 67.3163ZM69.5413 66.3056C80.2766 53.9164 78.9442 35.1565 66.555 24.4059C54.1658 13.6553 35.4059 14.9877 24.6554 27.3769C13.9048 39.7814 15.2371 58.5413 27.6416 69.2765C40.0308 80.0271 58.7907 78.6948 69.5413 66.3056Z"
        fill="url(#paint4_radial_14427_90552)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.6953 44.008C84.6953 66.3668 66.3387 84.4988 43.7031 84.4988C21.0519 84.4988 2.69531 66.3668 2.69531 44.008C2.69531 21.634 21.0519 3.50195 43.7031 3.50195C66.3387 3.50195 84.6953 21.634 84.6953 44.008ZM81.61 41.6956C79.9201 23.2879 65.5325 6.07474 46.8193 6.07474C39.8116 6.07474 37.2535 15.8605 29.2379 16.0596C11.6411 16.5037 5.0519 31.4504 5.0519 42.9973C5.0519 61.4662 25.331 59.0619 40.6643 78.6181C52.1217 93.2126 83.8116 65.5858 81.61 41.6956Z"
        fill="url(#paint5_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M21.2116 73.4263C19.1595 73.4263 17.4902 71.757 17.4902 69.7049C17.4902 67.6681 19.1595 65.9989 21.2116 65.9989C23.2637 65.9989 24.9176 67.6681 24.9176 69.7049C24.9176 71.757 23.2637 73.4263 21.2116 73.4263Z"
        fill="url(#paint6_radial_14427_90552)"
      />
      <path
        d="M24.6919 69.705C24.6919 71.6345 23.1299 73.1813 21.2156 73.1813C19.286 73.1813 17.7393 71.6345 17.7393 69.705C17.7393 67.7907 19.286 66.2286 21.2156 66.2286C23.1299 66.2286 24.6919 67.7907 24.6919 69.705Z"
        fill="url(#paint7_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M23.6438 69.7357C23.6438 71.2059 22.4493 72.3851 20.9791 72.3851C19.509 72.3851 18.3145 71.2059 18.3145 69.7357C18.3145 68.2655 19.509 67.071 20.9791 67.071C22.4493 67.071 23.6438 68.2655 23.6438 69.7357Z"
        fill="url(#paint8_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M21.5921 68.3881C21.5921 69.1078 20.9948 69.7051 20.275 69.7051C19.5553 69.7051 18.958 69.1078 18.958 68.3881C18.958 67.653 19.5553 67.071 20.275 67.071C20.9948 67.071 21.5921 67.653 21.5921 68.3881Z"
        fill="url(#paint9_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M16.5556 20.9753C15.2998 20.9753 14.2891 19.9493 14.2891 18.7088C14.2891 17.4684 15.2998 16.4576 16.5556 16.4576C17.796 16.4576 18.8068 17.4684 18.8068 18.7088C18.8068 19.9493 17.796 20.9753 16.5556 20.9753Z"
        fill="url(#paint10_radial_14427_90552)"
      />
      <path
        d="M18.6681 18.7088C18.6681 19.8727 17.7186 20.8222 16.5548 20.8222C15.3909 20.8222 14.4414 19.8727 14.4414 18.7088C14.4414 17.5449 15.3909 16.5955 16.5548 16.5955C17.7186 16.5955 18.6681 17.5449 18.6681 18.7088Z"
        fill="url(#paint11_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M18.0252 18.7241C18.0252 19.6124 17.3055 20.3321 16.4173 20.3321C15.529 20.3321 14.7939 19.6124 14.7939 18.7241C14.7939 17.8359 15.529 17.1008 16.4173 17.1008C17.3055 17.1008 18.0252 17.8359 18.0252 18.7241Z"
        fill="url(#paint12_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M16.789 17.9125C16.789 18.3413 16.4367 18.7088 15.9926 18.7088C15.5485 18.7088 15.1963 18.3413 15.1963 17.9125C15.1963 17.4684 15.5485 17.1008 15.9926 17.1008C16.4367 17.1008 16.789 17.4684 16.789 17.9125Z"
        fill="url(#paint13_radial_14427_90552)"
      />
      <g style={{mixBlendMode: 'screen'}}>
        <path
          d="M28.5964 75.8305C27.6316 75.8305 26.8506 75.0495 26.8506 74.0847C26.8506 73.1199 27.6316 72.3389 28.5964 72.3389C29.5459 72.3389 30.3422 73.1199 30.3422 74.0847C30.3422 75.0495 29.5459 75.8305 28.5964 75.8305Z"
          fill="url(#paint14_radial_14427_90552)"
        />
      </g>
      <path
        d="M30.2229 74.0848C30.2229 74.9883 29.5031 75.7234 28.5996 75.7234C27.696 75.7234 26.9609 74.9883 26.9609 74.0848C26.9609 73.1813 27.696 72.4462 28.5996 72.4462C29.5031 72.4462 30.2229 73.1813 30.2229 74.0848Z"
        fill="url(#paint15_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M29.7277 74.1C29.7277 74.7891 29.1763 75.3405 28.4872 75.3405C27.7981 75.3405 27.2314 74.7891 27.2314 74.1C27.2314 73.3956 27.7981 72.8442 28.4872 72.8442C29.1763 72.8442 29.7277 73.3956 29.7277 74.1Z"
        fill="url(#paint16_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M28.7681 73.4568C28.7681 73.7937 28.4924 74.0847 28.1555 74.0847C27.8186 74.0847 27.543 73.7937 27.543 73.4568C27.543 73.1199 27.8186 72.8442 28.1555 72.8442C28.4924 72.8442 28.7681 73.1199 28.7681 73.4568Z"
        fill="url(#paint17_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M5.38907 51.6499C4.60804 51.6499 3.96484 51.022 3.96484 50.241C3.96484 49.4447 4.60804 48.8168 5.38907 48.8168C6.17009 48.8168 6.81328 49.4447 6.81328 50.241C6.81328 51.022 6.17009 51.6499 5.38907 51.6499Z"
        fill="url(#paint18_radial_14427_90552)"
      />
      <path
        d="M6.7262 50.2408C6.7262 50.9759 6.12894 51.5578 5.39386 51.5578C4.65878 51.5578 4.06152 50.9759 4.06152 50.2408C4.06152 49.5057 4.65878 48.9084 5.39386 48.9084C6.12894 48.9084 6.7262 49.5057 6.7262 50.2408Z"
        fill="url(#paint19_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M6.31999 50.2412C6.31999 50.8078 5.86057 51.2673 5.30926 51.2673C4.74263 51.2673 4.2832 50.8078 4.2832 50.2412C4.2832 49.6899 4.74263 49.2305 5.30926 49.2305C5.86057 49.2305 6.31999 49.6899 6.31999 50.2412Z"
        fill="url(#paint20_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M5.54297 49.7358C5.54297 50.0115 5.31325 50.2259 5.0376 50.2259C4.76194 50.2259 4.53223 50.0115 4.53223 49.7358C4.53223 49.4449 4.76194 49.2305 5.0376 49.2305C5.31325 49.2305 5.54297 49.4449 5.54297 49.7358Z"
        fill="url(#paint21_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M19.4569 15.5241C18.9822 15.5241 18.584 15.126 18.584 14.6512C18.584 14.1612 18.9822 13.7783 19.4569 13.7783C19.9469 13.7783 20.3298 14.1612 20.3298 14.6512C20.3298 15.126 19.9469 15.5241 19.4569 15.5241Z"
        fill="url(#paint22_radial_14427_90552)"
      />
      <path
        d="M20.2851 14.6512C20.2851 15.0953 19.9176 15.4628 19.4581 15.4628C19.014 15.4628 18.6465 15.0953 18.6465 14.6512C18.6465 14.1918 19.014 13.8242 19.4581 13.8242C19.9176 13.8242 20.2851 14.1918 20.2851 14.6512Z"
        fill="url(#paint23_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M20.0409 14.6511C20.0409 15.0033 19.7653 15.279 19.413 15.279C19.0608 15.279 18.7852 15.0033 18.7852 14.6511C18.7852 14.3142 19.0608 14.0232 19.413 14.0232C19.7653 14.0232 20.0409 14.3142 20.0409 14.6511Z"
        fill="url(#paint24_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M19.5501 14.3295C19.5501 14.5132 19.4122 14.6511 19.2438 14.6511C19.0753 14.6511 18.9375 14.5132 18.9375 14.3295C18.9375 14.161 19.0753 14.0232 19.2438 14.0232C19.4122 14.0232 19.5501 14.161 19.5501 14.3295Z"
        fill="url(#paint25_radial_14427_90552)"
      />
      <g style={{mixBlendMode: 'screen'}}>
        <path
          d="M31.3435 14.0073C30.3787 14.0073 29.5977 13.2262 29.5977 12.2614C29.5977 11.2966 30.3787 10.5156 31.3435 10.5156C32.3083 10.5156 33.0893 11.2966 33.0893 12.2614C33.0893 13.2262 32.3083 14.0073 31.3435 14.0073Z"
          fill="url(#paint26_radial_14427_90552)"
        />
      </g>
      <path
        d="M32.9852 12.2614C32.9852 13.1649 32.2502 13.9 31.3466 13.9C30.4431 13.9 29.708 13.1649 29.708 12.2614C29.708 11.3578 30.4431 10.6381 31.3466 10.6381C32.2502 10.6381 32.9852 11.3578 32.9852 12.2614Z"
        fill="url(#paint27_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M32.4884 12.2768C32.4884 12.9659 31.9218 13.5172 31.2326 13.5172C30.5435 13.5172 29.9922 12.9659 29.9922 12.2768C29.9922 11.5876 30.5435 11.021 31.2326 11.021C31.9218 11.021 32.4884 11.5876 32.4884 12.2768Z"
        fill="url(#paint28_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M31.5305 11.6489C31.5305 11.9858 31.2548 12.2614 30.9179 12.2614C30.5657 12.2614 30.29 11.9858 30.29 11.6489C30.29 11.2967 30.5657 11.021 30.9179 11.021C31.2548 11.021 31.5305 11.2967 31.5305 11.6489Z"
        fill="url(#paint29_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M7.58762 56.9788C6.80659 56.9788 6.17871 56.3509 6.17871 55.5852C6.17871 54.8042 6.80659 54.1763 7.58762 54.1763C8.35333 54.1763 8.98121 54.8042 8.98121 55.5852C8.98121 56.3509 8.35333 56.9788 7.58762 56.9788Z"
        fill="url(#paint30_radial_14427_90552)"
      />
      <path
        d="M8.89412 55.585C8.89412 56.3047 8.31218 56.8867 7.59241 56.8867C6.85733 56.8867 6.27539 56.3047 6.27539 55.585C6.27539 54.8499 6.85733 54.2679 7.59241 54.2679C8.31218 54.2679 8.89412 54.8499 8.89412 55.585Z"
        fill="url(#paint31_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M8.51171 55.5851C8.51171 56.1364 8.05228 56.5958 7.50097 56.5958C6.94966 56.5958 6.49023 56.1364 6.49023 55.5851C6.49023 55.0338 6.94966 54.5743 7.50097 54.5743C8.05228 54.5743 8.51171 55.0338 8.51171 55.5851Z"
        fill="url(#paint32_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M7.72101 55.0797C7.72101 55.3554 7.50661 55.5698 7.23096 55.5698C6.9553 55.5698 6.72559 55.3554 6.72559 55.0797C6.72559 54.8041 6.9553 54.5743 7.23096 54.5743C7.50661 54.5743 7.72101 54.8041 7.72101 55.0797Z"
        fill="url(#paint33_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M13.48 64.5902C12.99 64.5902 12.5918 64.1921 12.5918 63.7173C12.5918 63.2273 12.99 62.8291 13.48 62.8291C13.9548 62.8291 14.3529 63.2273 14.3529 63.7173C14.3529 64.1921 13.9548 64.5902 13.48 64.5902Z"
        fill="url(#paint34_radial_14427_90552)"
      />
      <path
        d="M14.2929 63.7171C14.2929 64.1612 13.9254 64.5288 13.4813 64.5288C13.0218 64.5288 12.6543 64.1612 12.6543 63.7171C12.6543 63.2577 13.0218 62.8901 13.4813 62.8901C13.9254 62.8901 14.2929 63.2577 14.2929 63.7171Z"
        fill="url(#paint35_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M14.0487 63.7175C14.0487 64.0697 13.7731 64.3454 13.4209 64.3454C13.0839 64.3454 12.793 64.0697 12.793 63.7175C12.793 63.3653 13.0839 63.0896 13.4209 63.0896C13.7731 63.0896 14.0487 63.3653 14.0487 63.7175Z"
        fill="url(#paint36_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M13.5732 63.3959C13.5732 63.5643 13.4201 63.7022 13.2516 63.7022C13.0831 63.7022 12.9453 63.5643 12.9453 63.3959C12.9453 63.2274 13.0831 63.0896 13.2516 63.0896C13.4201 63.0896 13.5732 63.2274 13.5732 63.3959Z"
        fill="url(#paint37_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M17.9007 63.3652C17.3494 63.3652 16.9053 62.9211 16.9053 62.3698C16.9053 61.8338 17.3494 61.3744 17.9007 61.3744C18.452 61.3744 18.8961 61.8338 18.8961 62.3698C18.8961 62.9211 18.452 63.3652 17.9007 63.3652Z"
        fill="url(#paint38_radial_14427_90552)"
      />
      <path
        d="M18.8361 62.3698C18.8361 62.8905 18.4226 63.3039 17.9019 63.3039C17.3966 63.3039 16.9678 62.8905 16.9678 62.3698C16.9678 61.8644 17.3966 61.4509 17.9019 61.4509C18.4226 61.4509 18.8361 61.8644 18.8361 62.3698Z"
        fill="url(#paint39_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M18.558 62.3849C18.558 62.7831 18.2364 63.0894 17.8382 63.0894C17.4554 63.0894 17.1338 62.7831 17.1338 62.3849C17.1338 61.9868 17.4554 61.6652 17.8382 61.6652C18.2364 61.6652 18.558 61.9868 18.558 62.3849Z"
        fill="url(#paint40_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M18.0043 62.0174C18.0043 62.2165 17.8511 62.3696 17.652 62.3696C17.4529 62.3696 17.2998 62.2165 17.2998 62.0174C17.2998 61.8336 17.4529 61.6652 17.652 61.6652C17.8511 61.6652 18.0043 61.8336 18.0043 62.0174Z"
        fill="url(#paint41_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M34.3341 80.4096C33.9053 80.4096 33.5684 80.0727 33.5684 79.6439C33.5684 79.2304 33.9053 78.8782 34.3341 78.8782C34.7476 78.8782 35.0998 79.2304 35.0998 79.6439C35.0998 80.0727 34.7476 80.4096 34.3341 80.4096Z"
        fill="url(#paint42_radial_14427_90552)"
      />
      <path
        d="M35.0414 79.6437C35.0414 80.0418 34.7198 80.3634 34.337 80.3634C33.9388 80.3634 33.6172 80.0418 33.6172 79.6437C33.6172 79.2455 33.9388 78.9392 34.337 78.9392C34.7198 78.9392 35.0414 79.2455 35.0414 79.6437Z"
        fill="url(#paint43_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M34.8217 79.6592C34.8217 79.9502 34.5767 80.1952 34.2857 80.1952C33.9794 80.1952 33.7344 79.9502 33.7344 79.6592C33.7344 79.3529 33.9794 79.1079 34.2857 79.1079C34.5767 79.1079 34.8217 79.3529 34.8217 79.6592Z"
        fill="url(#paint44_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M34.4107 79.3683C34.4107 79.5214 34.2882 79.6439 34.135 79.6439C33.9819 79.6439 33.8594 79.5214 33.8594 79.3683C33.8594 79.2304 33.9819 79.1079 34.135 79.1079C34.2882 79.1079 34.4107 79.2304 34.4107 79.3683Z"
        fill="url(#paint45_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M25.8516 14.6504C25.4382 14.6504 25.0859 14.2982 25.0859 13.8847C25.0859 13.4559 25.4382 13.119 25.8516 13.119C26.2804 13.119 26.6174 13.4559 26.6174 13.8847C26.6174 14.2982 26.2804 14.6504 25.8516 14.6504Z"
        fill="url(#paint46_radial_14427_90552)"
      />
      <path
        d="M26.5743 13.8847C26.5743 14.2829 26.2527 14.6045 25.8545 14.6045C25.4564 14.6045 25.1348 14.2829 25.1348 13.8847C25.1348 13.4865 25.4564 13.1649 25.8545 13.1649C26.2527 13.1649 26.5743 13.4865 26.5743 13.8847Z"
        fill="url(#paint47_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M26.3546 13.8849C26.3546 14.1912 26.1095 14.4362 25.8033 14.4362C25.5123 14.4362 25.252 14.1912 25.252 13.8849C25.252 13.5786 25.5123 13.3336 25.8033 13.3336C26.1095 13.3336 26.3546 13.5786 26.3546 13.8849Z"
        fill="url(#paint48_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M25.9335 13.6093C25.9335 13.7624 25.8263 13.8849 25.6731 13.8849C25.52 13.8849 25.3975 13.7624 25.3975 13.6093C25.3975 13.4561 25.52 13.3336 25.6731 13.3336C25.8263 13.3336 25.9335 13.4561 25.9335 13.6093Z"
        fill="url(#paint49_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M32.7537 8.38706C32.1411 8.38706 31.6357 7.89701 31.6357 7.28444C31.6357 6.67187 32.1411 6.1665 32.7537 6.1665C33.3662 6.1665 33.8563 6.67187 33.8563 7.28444C33.8563 7.89701 33.3662 8.38706 32.7537 8.38706Z"
        fill="url(#paint50_radial_14427_90552)"
      />
      <path
        d="M33.7946 7.28441C33.7946 7.85103 33.3199 8.32577 32.7533 8.32577C32.1713 8.32577 31.7119 7.85103 31.7119 7.28441C31.7119 6.70247 32.1713 6.24304 32.7533 6.24304C33.3199 6.24304 33.7946 6.70247 33.7946 7.28441Z"
        fill="url(#paint51_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M33.4758 7.28438C33.4758 7.72849 33.1236 8.08072 32.6795 8.08072C32.2507 8.08072 31.8984 7.72849 31.8984 7.28438C31.8984 6.85558 32.2507 6.48804 32.6795 6.48804C33.1236 6.48804 33.4758 6.85558 33.4758 7.28438Z"
        fill="url(#paint52_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M32.8601 6.88621C32.8601 7.10061 32.6917 7.28438 32.4773 7.28438C32.2629 7.28438 32.0791 7.10061 32.0791 6.88621C32.0791 6.67181 32.2629 6.48804 32.4773 6.48804C32.6917 6.48804 32.8601 6.67181 32.8601 6.88621Z"
        fill="url(#paint53_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M33.5659 76.0755C33.1065 76.0755 32.7236 75.6926 32.7236 75.2179C32.7236 74.7585 33.1065 74.3756 33.5659 74.3756C34.0407 74.3756 34.4235 74.7585 34.4235 75.2179C34.4235 75.6926 34.0407 76.0755 33.5659 76.0755Z"
        fill="url(#paint54_radial_14427_90552)"
      />
      <path
        d="M34.3805 75.2182C34.3805 75.6623 34.0129 76.0145 33.5688 76.0145C33.14 76.0145 32.7725 75.6623 32.7725 75.2182C32.7725 74.7741 33.14 74.4219 33.5688 74.4219C34.0129 74.4219 34.3805 74.7741 34.3805 75.2182Z"
        fill="url(#paint55_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M34.1285 75.2331C34.1285 75.57 33.8528 75.8303 33.5159 75.8303C33.179 75.8303 32.9033 75.57 32.9033 75.2331C32.9033 74.8961 33.179 74.6205 33.5159 74.6205C33.8528 74.6205 34.1285 74.8961 34.1285 75.2331Z"
        fill="url(#paint56_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M33.6529 74.9114C33.6529 75.0799 33.5151 75.2177 33.3466 75.2177C33.1935 75.2177 33.0557 75.0799 33.0557 74.9114C33.0557 74.743 33.1935 74.6205 33.3466 74.6205C33.5151 74.6205 33.6529 74.743 33.6529 74.9114Z"
        fill="url(#paint57_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M36.5728 9.06098C36.2971 9.06098 36.0674 8.83126 36.0674 8.57092C36.0674 8.29526 36.2971 8.06555 36.5728 8.06555C36.8331 8.06555 37.0628 8.29526 37.0628 8.57092C37.0628 8.83126 36.8331 9.06098 36.5728 9.06098Z"
        fill="url(#paint58_radial_14427_90552)"
      />
      <path
        d="M37.0357 8.57088C37.0357 8.8159 36.8213 9.0303 36.5763 9.0303C36.316 9.0303 36.1016 8.8159 36.1016 8.57088C36.1016 8.31053 36.316 8.11145 36.5763 8.11145C36.8213 8.11145 37.0357 8.31053 37.0357 8.57088Z"
        fill="url(#paint59_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M36.89 8.57097C36.89 8.77006 36.7215 8.9232 36.5378 8.9232C36.3387 8.9232 36.1855 8.77006 36.1855 8.57097C36.1855 8.37189 36.3387 8.21875 36.5378 8.21875C36.7215 8.21875 36.89 8.37189 36.89 8.57097Z"
        fill="url(#paint60_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M36.6208 8.38721C36.6208 8.47909 36.5442 8.57097 36.437 8.57097C36.3451 8.57097 36.2686 8.47909 36.2686 8.38721C36.2686 8.29532 36.3451 8.21875 36.437 8.21875C36.5442 8.21875 36.6208 8.29532 36.6208 8.38721Z"
        fill="url(#paint61_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M13.0034 67.8523C12.5593 67.8523 12.207 67.4848 12.207 67.0407C12.207 66.5965 12.5593 66.229 13.0034 66.229C13.4475 66.229 13.815 66.5965 13.815 67.0407C13.815 67.4848 13.4475 67.8523 13.0034 67.8523Z"
        fill="url(#paint62_radial_14427_90552)"
      />
      <path
        d="M13.772 67.0408C13.772 67.4543 13.4351 67.8065 13.0063 67.8065C12.5928 67.8065 12.2559 67.4543 12.2559 67.0408C12.2559 66.6273 12.5928 66.2904 13.0063 66.2904C13.4351 66.2904 13.772 66.6273 13.772 67.0408Z"
        fill="url(#paint63_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M13.5369 67.0563C13.5369 67.3626 13.2766 67.6229 12.955 67.6229C12.6334 67.6229 12.373 67.3626 12.373 67.0563C12.373 66.7347 12.6334 66.4744 12.955 66.4744C13.2766 66.4744 13.5369 66.7347 13.5369 67.0563Z"
        fill="url(#paint64_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M13.1005 66.75C13.1005 66.9185 12.9627 67.041 12.8095 67.041C12.6564 67.041 12.5186 66.9185 12.5186 66.75C12.5186 66.5969 12.6564 66.4744 12.8095 66.4744C12.9627 66.4744 13.1005 66.5969 13.1005 66.75Z"
        fill="url(#paint65_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M10.4009 60.7458C9.94145 60.7458 9.55859 60.3629 9.55859 59.9035C9.55859 59.4287 9.94145 59.0459 10.4009 59.0459C10.8756 59.0459 11.2585 59.4287 11.2585 59.9035C11.2585 60.3629 10.8756 60.7458 10.4009 60.7458Z"
        fill="url(#paint66_radial_14427_90552)"
      />
      <path
        d="M11.2154 59.9033C11.2154 60.3321 10.8479 60.6996 10.4038 60.6996C9.97496 60.6996 9.60742 60.3321 9.60742 59.9033C9.60742 59.4592 9.97496 59.1069 10.4038 59.1069C10.8479 59.1069 11.2154 59.4592 11.2154 59.9033Z"
        fill="url(#paint67_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M10.9634 59.9033C10.9634 60.2403 10.6878 60.5159 10.3508 60.5159C10.0139 60.5159 9.73828 60.2403 9.73828 59.9033C9.73828 59.5664 10.0139 59.2908 10.3508 59.2908C10.6878 59.2908 10.9634 59.5664 10.9634 59.9033Z"
        fill="url(#paint68_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M10.4879 59.5971C10.4879 59.7655 10.3501 59.888 10.1969 59.888C10.0285 59.888 9.89062 59.7655 9.89062 59.5971C9.89062 59.4286 10.0285 59.2908 10.1969 59.2908C10.3501 59.2908 10.4879 59.4286 10.4879 59.5971Z"
        fill="url(#paint69_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M39.0983 82.2316C38.9146 82.2316 38.7461 82.0784 38.7461 81.8793C38.7461 81.6956 38.9146 81.5271 39.0983 81.5271C39.2974 81.5271 39.4505 81.6956 39.4505 81.8793C39.4505 82.0784 39.2974 82.2316 39.0983 82.2316Z"
        fill="url(#paint70_radial_14427_90552)"
      />
      <path
        d="M39.4388 81.8795C39.4388 82.0632 39.2856 82.2164 39.1019 82.2164C38.9181 82.2164 38.7803 82.0632 38.7803 81.8795C38.7803 81.6957 38.9181 81.5579 39.1019 81.5579C39.2856 81.5579 39.4388 81.6957 39.4388 81.8795Z"
        fill="url(#paint71_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M39.3276 81.8794C39.3276 82.0173 39.2204 82.1398 39.0826 82.1398C38.9448 82.1398 38.8223 82.0173 38.8223 81.8794C38.8223 81.7416 38.9448 81.6344 39.0826 81.6344C39.2204 81.6344 39.3276 81.7416 39.3276 81.8794Z"
        fill="url(#paint72_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M39.1451 81.7569C39.1451 81.8182 39.0839 81.8794 39.0226 81.8794C38.946 81.8794 38.8848 81.8182 38.8848 81.7569C38.8848 81.6803 38.946 81.6344 39.0226 81.6344C39.0839 81.6344 39.1451 81.6803 39.1451 81.7569Z"
        fill="url(#paint73_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M29.5837 78.8633C29.3999 78.8633 29.2314 78.7101 29.2314 78.511C29.2314 78.3273 29.3999 78.1588 29.5837 78.1588C29.7828 78.1588 29.9359 78.3273 29.9359 78.511C29.9359 78.7101 29.7828 78.8633 29.5837 78.8633Z"
        fill="url(#paint74_radial_14427_90552)"
      />
      <path
        d="M29.9241 78.5112C29.9241 78.6949 29.771 78.8481 29.5872 78.8481C29.4035 78.8481 29.2656 78.6949 29.2656 78.5112C29.2656 78.3427 29.4035 78.1896 29.5872 78.1896C29.771 78.1896 29.9241 78.3427 29.9241 78.5112Z"
        fill="url(#paint75_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        opacity="0.5"
        d="M29.813 78.5265C29.813 78.6643 29.7058 78.7715 29.568 78.7715C29.4301 78.7715 29.3076 78.6643 29.3076 78.5265C29.3076 78.3733 29.4301 78.2661 29.568 78.2661C29.7058 78.2661 29.813 78.3733 29.813 78.5265Z"
        fill="url(#paint76_radial_14427_90552)"
      />
      <path
        style={{mixBlendMode: 'screen'}}
        d="M29.6305 78.3886C29.6305 78.4652 29.5692 78.5111 29.4926 78.5111C29.4314 78.5111 29.3701 78.4652 29.3701 78.3886C29.3701 78.3274 29.4314 78.2661 29.4926 78.2661C29.5692 78.2661 29.6305 78.3274 29.6305 78.3886Z"
        fill="url(#paint77_radial_14427_90552)"
      />
      <defs>
        <radialGradient
          id="paint0_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(43.5077 44.0077) scale(44.9778)"
        >
          <stop offset="0.7" stopColor="#FEFEFE" stopOpacity="0" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_14427_90552"
          x1="55.4345"
          y1="140.241"
          x2="-48.6968"
          y2="36.1094"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEFEFE" stopOpacity="0" />
          <stop offset="1" stopColor="#FEFEFE" />
        </linearGradient>
        <radialGradient
          id="paint2_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(59.1722 45.0645) scale(53.5232)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-28.7132 9.65807) scale(83.3246 83.3246)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-28.7146 9.65834) scale(83.3246 83.3246)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(43.7031 44.008) scale(41.3953 40.8889)"
        >
          <stop offset="0.5" stopColor="#D2D3D4" />
          <stop offset="0.7" stopColor="#FEFEFE" />
          <stop offset="0.9" stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(25.5455 72.9056) scale(5.83471)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(22.5873 69.7963) scale(4.59435 4.59435)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(21.1476 65.8306) scale(5.31403 5.31402)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.1372 68.4187) scale(0.980109 0.980107)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.1896 20.6537) scale(3.53758)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.3887 18.7644) scale(2.79304)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.5245 16.3504) scale(3.2313)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.9161 17.9278) scale(0.597254)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint14_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(29.2853 74.1306) scale(2.30729)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint15_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(29.2355 74.1279) scale(2.1555 2.16562)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint16_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.5638 72.2623) scale(2.49621 2.49622)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint17_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(28.0943 73.4721) scale(0.459426 0.459428)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint18_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.05831 51.4508) scale(2.22056 2.22056)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint19_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.91959 50.2679) scale(1.76083 1.75071)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint20_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(5.37051 48.7557) scale(2.03679 2.03679)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint21_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.99165 49.7358) scale(0.382856)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint22_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.4829 15.4016) scale(1.36297 1.36296)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint23_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.7891 14.6651) scale(1.08281 1.08281)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint24_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.459 13.7322) scale(1.25576 1.25577)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint25_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.2132 14.3448) scale(0.229713)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint26_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(32.0324 12.3073) scale(2.30729)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint27_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(31.9932 12.3119) scale(2.16562 2.1555)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint28_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(31.3092 10.4391) scale(2.49622)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint29_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(30.8413 11.6489) scale(0.459425 0.459427)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint30_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.22624 56.7797) scale(2.20525 2.20524)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint31_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.10142 55.6117) scale(1.73047 1.73047)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint32_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.56223 54.1149) scale(2.00616 2.00616)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint33_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.1697 55.0797) scale(0.367541)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint34_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.4908 64.4677) scale(1.37828)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint35_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.7969 63.731) scale(1.08281 1.08281)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint36_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.4668 62.7986) scale(1.25577 1.25576)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint37_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.221 63.4112) scale(0.229713)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint38_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(19.0646 63.2274) scale(1.56205)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint39_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.2706 62.4018) scale(1.2346 1.22448)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint40_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.8842 61.3436) scale(1.42422 1.42423)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint41_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.6214 62.0327) scale(0.260342 0.260344)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint42_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(35.2223 80.3024) scale(1.19451)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint43_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34.6103 79.67) scale(0.941135 0.941132)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint44_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34.3163 78.8476) scale(1.10262)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint45_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34.1044 79.3836) scale(0.199085)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint46_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(26.7552 14.5432) scale(1.19451)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint47_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(26.1385 13.9036) scale(0.951252)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint48_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(25.8492 13.0886) scale(1.10262)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint49_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(25.6425 13.6093) scale(0.199085)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint50_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34.0401 8.23392) scale(1.74582)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint51_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(33.1642 7.31177) scale(1.37628 1.37628)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint52_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(32.7407 6.1205) scale(1.59268 1.59268)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint53_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(32.4313 6.90152) scale(0.29097)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint54_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(34.5613 75.953) scale(1.33234 1.33234)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint55_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(33.8937 75.2391) scale(1.06257 1.05245)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint56_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(33.5618 74.3295) scale(1.22514 1.22513)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint57_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(33.316 74.9268) scale(0.229715 0.229711)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint58_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(37.1394 8.9844) scale(0.781025)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint59_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(36.753 8.58295) scale(0.617303 0.607183)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint60_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(36.5531 8.05029) scale(0.70445 0.704454)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint61_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(36.4217 8.38721) scale(0.137827)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint62_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.9529 67.7451) scale(1.27108 1.27108)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint63_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.313 67.0684) scale(1.00185 1.00185)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint64_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(13.0009 66.1987) scale(1.14857)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint65_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.7789 66.7653) scale(0.214398 0.2144)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint66_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.4116 60.6386) scale(1.33233 1.33233)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint67_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.7287 59.9242) scale(1.06257 1.05245)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint68_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.3968 59.0151) scale(1.22514)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint69_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.1663 59.5971) scale(0.229713 0.229715)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint70_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(39.5118 82.1856) scale(0.551312 0.551316)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint71_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(39.2394 81.8958) scale(0.435146)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint72_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(39.0979 81.5119) scale(0.505372 0.505367)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint73_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(39.0073 81.7569) scale(0.0918859 0.0918838)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint74_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(29.9972 78.8173) scale(0.551312 0.551316)"
        >
          <stop stopColor="#0A0B0B" />
          <stop offset="1" stopColor="#FEFEFE" />
        </radialGradient>
        <radialGradient
          id="paint75_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(29.7248 78.5275) scale(0.435146)"
        >
          <stop offset="0.3" stopColor="#DB8605" />
          <stop offset="1" stopColor="#F9C818" />
        </radialGradient>
        <radialGradient
          id="paint76_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(29.5833 78.1436) scale(0.505372 0.505367)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
        <radialGradient
          id="paint77_radial_14427_90552"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(29.4926 78.3886) scale(0.0918842)"
        >
          <stop stopColor="#FEFEFE" />
          <stop offset="1" stopColor="#0A0B0B" />
        </radialGradient>
      </defs>
    </svg>
  );
};
